import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { checkEvaluation, initMenu } from "../../redux/actions/student";
import Header from "../common/Header";

export default function StudentMenu() {
  const [selectList, setSelectList] = useState();
  const dispatch = useDispatch();
  const list = useSelector(state => state.student.list);
  const term = useSelector(state => state.student.term);
  const student = useSelector(state => state.student.student);
  useEffect(
    () => {
      dispatch(initMenu());
    },
    [dispatch]
  );

  const handleRadioChange = event => {
    setSelectList(event.target.value);
    console.log("評価リストID:", event.target.value);
  };

  const handleEvaluationTransition = () => {
    const param = {
      listId: selectList,
      termId: term.termId,
      student: student
    };
    dispatch(checkEvaluation(param));
  };

  const handleKnowSelfTransition = () => {
    if (!selectList) {
      alert("評価の項目を選択してください。");
      return;
    }

    window.location.href = `/EvaluationConfirm?listId=${selectList}&termId=${term.termId}`;
  };
  const handlePlaningTransition = () => {
    if (!selectList) {
      alert("評価の項目を選択してください。");
      return;
    }
    window.location.href = `/PlaningSheet?listId=${selectList}&termId=${term.termId}`;
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Header />
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 9,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h5" variant="h6" align="left">
            メニュー
          </Typography>
        </Box>

        <Box
          sx={{
            marginTop: 2,
            alignItems: "center",
            justifyContent: "center",
            ml: 4
          }}
        >
          <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
            {list.map(list =>
              <FormControlLabel
                key={list.listId} // キーを追加
                value={list.listId}
                control={<Radio />}
                label={list.listName}
                onChange={handleRadioChange}
              />
            )}
          </RadioGroup>
        </Box>

        <Box
          sx={{
            margin: 1,
            display: "flex",
            marginBottom: 7
          }}
        >
          <div>
            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 1 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handleEvaluationTransition}
                sx={{ bgcolor: "#82b1ff" }}
              >
                1. 自分自身を見つめなおそう
              </Button>
            </FormControl>

            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 5 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handleKnowSelfTransition}
                sx={{ bgcolor: "#82b1ff" }}
              >
                2. 自分自身のことを知ろう
              </Button>
            </FormControl>

            <FormControl fullWidth sx={{ mr: 3, ml: 3, mt: 5 }}>
              <Button
                size="large"
                style={{ color: "white", justifyContent: "left" }}
                fullWidth
                variant="contained"
                onClick={handlePlaningTransition}
                sx={{ bgcolor: "#82b1ff" }}
              >
                3. これからの計画を立てよう
              </Button>
            </FormControl>
          </div>
        </Box>
      </Container>
    </Box>
  );
}
